import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseEstablishmentLeadsProps<T> = {
  filters?: {
    search?: string
    state?: string | string[]
    creatorId?: string
    showOnlyArchived?:boolean
  }
  mapper?: (data: any) => T,
}

export const useEstablishmentLeads = <T,>({
  filters: { search = '', state, creatorId, showOnlyArchived } = {},
  mapper = Mapper.default<T>(),
}: UseEstablishmentLeadsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['establishmentLeads', search, state, creatorId, showOnlyArchived],
    queryFn: () => {
      return privateAxios.get('/funnel/establishment/leads', {
        params: {
          search,
          'q[state_eq]': state,
          'q[creator_id_eq]': creatorId,
          'q[archived_at_not_null]': showOnlyArchived ? true : undefined,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
